import { connect } from 'react-redux';
import AgencyAppointments from './AgencyAppointments';
import {
  downloadAppointmentsReport,
  getSpecificAgencyData
} from 'state/actions/actions';
import withLocalLoader from 'components/HOCs/withLocalLoader';

function mapStateToProps({ agencyManagement }) {
  return {
    agencyData: agencyManagement.agencyData
  };
}

export default connect(mapStateToProps, {
  downloadAppointmentsReport,
  getSpecificAgencyData
})(
  withLocalLoader(
    AgencyAppointments,
    true,
    'Agency Management',
    'Agency Management'
  )
);
